import { Stack, Typography } from "@mui/material";
import React, { FC } from "react";

interface StepTitleProps {
	title: string;
	businessName?: string;
}

export const HeaderTitle: FC<StepTitleProps> = ({ title, businessName }) => {
	return (
		<Stack
			sx={{
				display: "flex",
				flexDirection: "row",
				pt: "4px",
			}}
		>
			<Typography
				variant="h2"
				sx={{ fontSize: { mobile: "26px", sm: "32px" } }}
			>
				{title}
				{businessName && (
					<>
						{" "}
						<Typography
							variant="h1"
							component="span"
							sx={{ fontSize: { mobile: "28px", sm: "34px" } }}
						>
							{businessName}
						</Typography>
					</>
				)}
			</Typography>
		</Stack>
	);
};
